import React, { useMemo } from 'react';
import styled from 'styled-components';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { panelTheme } from '../../PanelComerciales.theme';

const HeaderRoot = styled.header`
    background: ${panelTheme.colors.surface};
    border-bottom: 1px solid ${panelTheme.colors.border};
    padding: 12px 24px;
    position: sticky;
    top: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    gap: 16px;
    border-top-left-radius: ${panelTheme.radius.md};
    border-top-right-radius: ${panelTheme.radius.md};

    .brand {
        display: flex;
        flex-direction: column;
        line-height: 1.1;

        strong {
            font-size: 14px;
            color: ${panelTheme.colors.text};
        }
        span {
            font-size: 11px;
            color: ${panelTheme.colors.textMuted};
        }
    }

    .search {
        max-width: 320px;
        flex: 1 1 320px;
        margin-left: auto;

        .MuiOutlinedInput-root {
            border-radius: ${panelTheme.radius.md};
            background: ${panelTheme.colors.surfaceMuted};
        }
    }

    @media (max-width: 768px) {
        .search {
            display: none;
        }
    }
`;

interface StickyHeaderProps {
    onSearchChange?: (q: string) => void;
}

const StickyHeader: React.FC<StickyHeaderProps> = ({ onSearchChange }) => {
    const today = useMemo(
        () =>
            new Date().toLocaleDateString('es-MX', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            }),
        [],
    );

    return (
        <HeaderRoot>
            <div className='brand'>
                <strong>Panel de Controles Comerciales</strong>
                <span>{today}</span>
            </div>
            <TextField
                className='search'
                size='small'
                placeholder='Buscar comercial, equipo, cuenta...'
                onChange={(e) => onSearchChange?.(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position='start'>
                            <SearchIcon fontSize='small' />
                        </InputAdornment>
                    ),
                }}
            />
        </HeaderRoot>
    );
};

export default StickyHeader;
